import { STORAGE_TYPE } from '@util/storage';
import { useStateWithStorage } from './useStateWithStorage';

export const useStateWithLocalStorage = (
  storageKey,
  defaultValue,
  encrypt = process.env.ENABLE_DEV_FEATURES === 'true'
) => useStateWithStorage(STORAGE_TYPE.LOCAL, storageKey, defaultValue, encrypt);
